import { inject, Injectable } from '@angular/core';

import type { User } from './models';
import { canModifyUser, canActivateUser, canResendInvite, canDeactivateUser } from './rules';

import { PermissionService } from '@core/auth';

@Injectable({ providedIn: 'root' })
export class UserPolicy {
  private readonly permissions = inject(PermissionService);

  public canEdit(user: User): boolean {
    return this.permissions.has('edit_users') && canModifyUser(user);
  }

  public canResendInvite(user: User): boolean {
    return this.permissions.has('edit_users') && canResendInvite(user);
  }

  public canActivate(user: User): boolean {
    return this.permissions.has('edit_users') && canActivateUser(user);
  }

  public canDeactivate(user: User): boolean {
    return this.permissions.has('edit_users') && canDeactivateUser(user);
  }

  public canDelete(user: User): boolean {
    return this.permissions.has('delete_users') && canModifyUser(user);
  }
}
